module.exports = __webpack_public_path__ + "static/media/perl.8db19bca.png";